<template>
  <el-drawer
    v-model="showDrawer"
    ref="cleanTaskDrawer"
    custom-class="r-drawer"
    @open="handleOpen"
    @close="handleClose"
  >
    <template #title>
      <div class="font-18 font-bold color-black">保洁任务</div>
    </template>

    <div class="clean-task-container">
      <p class="font-18">房源信息</p>
      <div class="room-info font-18">
        <div class="info-line">
          <span>房源：{{ `${info.parentProps.roomName}（${info.parentProps.roomTypeName}）` }}</span>
          <span></span>
        </div>
        <div class="info-line">
          <span>日期：{{ info.fullDate }}</span>
          <span></span>
        </div>
      </div>
      <p class="font-18">任务列表</p>
      <div class="task-list">
        <template v-if="taskList.length">
          <div class="task-item font-18" v-for="task in taskList" :key="task.id">
            <div class="name-line">
              <img class="task-icon" :src="iconMap[task.status]" alt="">
              <span class="m-r-20">{{ task.staffName }}</span>
              <span>{{ task.staffPhone }}</span>
              <span class="poi-abs-r">{{ task.statusName }}</span>
            </div>
            <div class="time-line">
              <span>{{ `${task.typeName}，${task.timeStart} - ${task.timeEnd}` }}</span>
            </div>
            <div class="oper-line">
              <div class="btn-front">
                <el-button
                  class="drawer-btn"
                  type="primary"
                  size="small"
                  icon="VideoPlay"
                  :disabled="task.status != 1"
                  @click="checkCleanTaskStatus(task.id, 2)">开始</el-button>
                <el-button
                  class="drawer-btn color-warning"
                  type="primary"
                  size="small"
                  icon="CircleCheck"
                  :disabled="task.status === 3"
                  @click="checkCleanTaskStatus(task.id, 3)">结束</el-button>
              </div>
              <div class="btn-back">
                <el-button v-if="task.status != 2" class="plain-btn" type="primary" size="small" plain @click="handleAddOrEdit(task)">修改</el-button>
                <el-button v-if="task.status != 2" class="plain-btn plain-warning" type="primary" size="small" plain @click="delCleanTask(task.id)">删除</el-button>
              </div>
            </div>
          </div>
        </template>
        <div class="empty-container" v-else>
          当前日期没有保洁任务
        </div>
      </div>

      <div class="bottom-btn-container">
        <el-button class="color-orange" type="primary" @click="handleAddOrEdit">添加保洁</el-button>
      </div>

      <DrawerCleanEdit v-model="editDarwer" :info="info" :cleanTaskId="curTask.id" @success="getList" />
    </div>
  </el-drawer>
</template>

<script>
import { mapActions } from "vuex";

import iconCleaned from '@/assets/img/icon/icon-roomclean-done.png'
import iconCleaning from '@/assets/img/icon/icon-roomclean-doing.png'
import iconNeedClean from '@/assets/img/icon/icon-roomclean-before.png'

import DrawerCleanEdit from './drawerCleanEdit.vue'

export default {
  components: { DrawerCleanEdit },
  emits: ['input'],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      curTask: {},
      taskList: [],
      iconMap: {
        1: iconNeedClean,
        2: iconCleaning,
        3: iconCleaned
      },

      editDarwer: false,
      showDrawer: false,
    };
  },
  created() {
    this.showDrawer = this.value;
  },
  watch: {
    value(val) {
      this.showDrawer = val;
    }
  },
  methods: {
    ...mapActions(["fetchData"]),
    // 处理抽屉弹出
    handleOpen() {
      if (this.info.storeId) {
        this.getList()
      }
    },
    // 获取保洁任务列表
    getList() {
      let url = 'CLEAN.TASK.GET_LIST'
      let params = {
        queryDateEnd: this.info.fullDate + ' 23:59:59',
        queryDateStart: this.info.fullDate + ' 00:00:00',
        roomId: this.info.parentProps.roomId,
      }

      this.fetchData({ url, method: "get", params }).then((res) => {
        res = res?.data || []
        res.forEach(item => {
          item.typeName = item.type === 1 ? '简单' : ( item.type === 2 ? '标准' : '--' )
          item.timeEnd = item.taskEndTime?.slice(-8).slice(0, 5)
          item.timeStart = item.taskStartTime?.slice(-8).slice(0, 5)
        })
        this.taskList = res
      });
    },
    // 开始和结束任务
    checkCleanTaskStatus(cleanTaskId, status) {
      if (!cleanTaskId) return;

      this.fetchData({
        url: 'CLEAN.TASK.POST_SAVE',
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        params: { id: cleanTaskId, status }
      }).then(res => {
        if (res) {
          this.$message.success('操作成功')
          this.getList()
        } else {
          this.$message.error('操作失败')
        }
      }).catch(err => {
        this.$message.error('操作失败')
      })
    },
    // 删除
    delCleanTask(cleanTaskId) {
      if (!cleanTaskId) return;

      this.$confirm('确定删除该任务吗？', { type: 'warning' }).then(res => {
        if (res) {
          this.fetchData({
            url: 'CLEAN.TASK.DELETE',
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            params: [cleanTaskId]
          }).then(res => {
            if (res) {
              this.$message.success('操作成功')
              this.getList()
            } else {
              this.$message.error('操作失败')
            }
          }).catch(err => {
            this.$message.error('操作失败')
          })
        }
      })
    },
    // 处理关闭弹层
    handleClose() {
      this.$emit("input", false);
      this.$emit("close");
      this.$refs.cleanTaskDrawer.handleClose();
    },
    // 处理添加按钮点击
    handleAddOrEdit(task) {
      this.curTask = task || {}
      this.editDarwer = true
    },
  },
};
</script>

<style lang="less" scoped>
@colorPrimary: rgb(0, 192, 192);
@colorWarning: rgb(243, 134, 38);
@colorOrange: rgb(246, 100, 1);
@colorDisabled: #BBB;

.clean-task-container {
  position: relative;
  height: 100%;
}
.room-info, .empty-container {
  margin-bottom: 16px;
  padding: 17px 32px;
  background-color: rgb(241, 250, 255);
  border-radius: 3px;
  .info-line {
    margin-bottom: 10px;
    &:last-of-type {
      margin-bottom: 0px;
    }
  }
}
.task-list {
  padding: 5px;
  padding-bottom: 20px;
  max-height: calc(100% - 240px);
  overflow-y: auto;
  .task-item {
    padding: 17px;
    padding-left: 52px;
    margin-bottom: 18px;
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.17);
    &:last-of-type {
      margin-bottom: 0px;
    }
  }
  .oper-line {
    display: flex;
    justify-content: space-between;
  }
  .name-line, .time-line {
    position: relative;
    margin-bottom: 15px;
  }
  .task-icon {
    position: absolute;
    top: 2px;
    left: -32px;
    max-width: 22px;
    max-height: 22px;
  }
}
.empty-container {
  padding: 32px;
  text-align: center;
  color: #999;
}
.bottom-btn-container {
  position: absolute;
  bottom: 0px;
  margin: 0px -20px;
  padding: 21px 36px 0px 36px;
  width: calc(~"100% + 40px");
  box-shadow: 0px -6px 17px rgba(36, 176, 255, 0.13);
}

.poi-abs-r {
  position: absolute;
  right: 0px;
}
.plain-btn {
  color: @colorPrimary;
  background-color: white;
  border: 1px solid @colorPrimary;
}
.plain-warning {
  color: @colorWarning;
  border: 1px solid @colorWarning;
}
.drawer-btn.is-disabled {
  .color-disabled();
}
.color-warning {
  background-color: @colorWarning;
}
.color-orange {
  background-color: @colorOrange;
}
.color-disabled {
  background-color: @colorDisabled;
}
</style>